import React, { useState } from "react";
import ReactDOM from "react-dom";
import CustomPagination from "./CustomPagination";
import "../css/ModalConTabla.css";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ModalConTabla = ({ show, handleClose, data }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = data.slice(startIndex, endIndex);

    if (!show) return null;

    return ReactDOM.createPortal(
        <div className="modal-notificaciones">
            <div className="contenido">

                <div className="encabezado">
                    <span className="titulo-modal">
                        <FontAwesomeIcon icon={faBell} className="icono-campana" />
                        Notificaciones
                    </span>
                    <button className="cerrar" onClick={handleClose}>×</button>
                </div>

                <div className="lista">
                    {paginatedData.length > 0 ? (
                        paginatedData.map((empleado, index) => (
                            <div className="card-notificacion" key={index}>
                                <div className="header-noti">
                                    <span className={`estado-pill ${empleado.type === "I" ? "ingreso" :
                                        empleado.type === "E" ? "egreso" : "ausente"
                                        }`}>
                                        {empleado.type === "I" ? "Ingreso" : empleado.type === "E" ? "Egreso" : "Ausente"}
                                    </span>
                                    <span>{empleado.date}</span>
                                </div>

                                <div className="nombre">
                                    {empleado.name} {empleado.lastname}
                                </div>
                                <div className="detalle">
                                    {empleado.city.name} – {empleado.objective.name}
                                </div>
                                <div className="detalle">
                                    Puesto: {empleado.place.name}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="detalle" style={{ textAlign: "center" }}>No hay notificaciones disponibles.</p>
                    )}
                </div>

                <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                />

                <div className="footer">
                    <button className="btn-cerrar" onClick={handleClose}>Cerrar</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalConTabla;
